import type { CartLineItem } from "@wbly/data-storefront";
import type { AlgoliaProduct } from "../../../types/algolia-insights-types";

export function buildAlgoliaAddedToCartPayload(
  item: CartLineItem,
  match: AlgoliaProduct,
  currency: string
) {
  const itemPrice = parseFloat(item.solidus.price.amount);
  const discount = item.solidus.promoTotal?.amount
    ? Math.abs(parseFloat(item.solidus.promoTotal.amount))
    : 0;
  const itemValue = Number(
    ((itemPrice - discount) * item.solidus.quantity).toFixed(2)
  );

  return {
    eventName: "product_added_to_cart",
    index: match.index,
    queryID: match.queryId,
    objectIDs: [item.solidus.productSku],
    objectData: [
      {
        price: itemPrice,
        discount,
        quantity: item.solidus.quantity,
      },
    ],
    value: itemValue,
    currency,
  };
}
